import { Preferences } from '@capacitor/preferences';
import { pilotAuthLegacySession } from './auth';
import { getCachedSession, saveSession } from './user';

export function normalizeMobile(raw) {
  return String(raw || '').replace(/\D/g, '').slice(-10);
}

/** @returns {Promise<{ mobile: string } | null>} */
export async function readLegacySession() {
  const { value } = await Preferences.get({ key: 'userId' });
  const mobile = normalizeMobile(value);
  if (!/^[6789]\d{9}$/.test(mobile)) return null;
  return { mobile };
}

/**
 * If v2 has no JWT but legacy userId exists, exchange for Pilot token and persist v2_session.
 * @returns {Promise<object | null>} Saved session or null on skip/failure.
 */
export async function tryMigrateLegacySession() {
  const cached = await getCachedSession();
  if (cached?.token && cached?.mobile) {
    return cached;
  }

  const legacy = await readLegacySession();
  if (!legacy) return null;

  try {
    const data = await pilotAuthLegacySession({ mobile: legacy.mobile });
    const session = {
      ...(cached || {}),
      mobile: legacy.mobile,
      token: data.token,
      user: data.user,
    };
    await saveSession(session);
    return session;
  } catch {
    return null;
  }
}
